import React from "react";
import {
  View,
  Text,
  TouchableOpacity,
  Modal,
  StyleSheet,
  useWindowDimensions,
} from "react-native";

interface ErrorModalProps {
  visible: boolean;
  title: string;
  message: string;
  onTryAgain?: () => void;
  onGoToLobby?: () => void;
  onCancel: () => void;
}

const ErrorFindTableModal: React.FC<ErrorModalProps> = ({
  visible,
  title,
  message,
  onTryAgain,
  onGoToLobby,
  onCancel,
}) => {
  const { width } = useWindowDimensions();
  const isMobile = width < 768;

  return (
    <Modal
      visible={visible}
      transparent
      animationType="fade"
      onRequestClose={onCancel}
    >
      <View style={styles.overlay}>
        <View style={[styles.modalContainer, isMobile && styles.modalMobile]}>
          <Text style={styles.title}>{title}</Text>
          <Text style={styles.message}>{message}</Text>
          
          <View style={styles.buttonContainer}>
            {onGoToLobby && (
              <TouchableOpacity
                style={[styles.button, styles.lobbyButton]}
                onPress={onGoToLobby}
              >
                <Text style={styles.buttonText}>Go to Lobby</Text>
              </TouchableOpacity>
            )}
            
            {onTryAgain && (
              <TouchableOpacity
                style={[styles.button, styles.tryAgainButton]}
                onPress={onTryAgain}
              >
                <Text style={styles.buttonText}>Try Again</Text>
              </TouchableOpacity>
            )}
            
            <TouchableOpacity
              style={[styles.button, styles.cancelButton]}
              onPress={onCancel}
            >
              <Text style={styles.buttonText}>Cancel</Text>
            </TouchableOpacity>
          </View>
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  overlay: {
    flex: 1,
    backgroundColor: "rgba(0, 0, 0, 0.8)",
    justifyContent: "center",
    alignItems: "center",
    padding: 20,
  },
  modalContainer: {
    backgroundColor: "#131F33",
    borderRadius: 15,
    borderWidth: 2,
    borderColor: "#FBDE7F",
    padding: 30,
    width: "90%",
    maxWidth: 500,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 5,
  },
  modalMobile: {
    width: "95%",
    padding: 20,
  },
  title: {
    fontSize: 24,
    fontWeight: "bold",
    color: "#ffe593",
    marginBottom: 15,
    textAlign: "center",
  },
  message: {
    fontSize: 16,
    color: "#ffffff",
    marginBottom: 25,
    textAlign: "center",
    lineHeight: 24,
  },
  buttonContainer: {
    flexDirection: "column",
    gap: 10,
  },
  button: {
    paddingVertical: 12,
    paddingHorizontal: 20,
    borderRadius: 8,
    alignItems: "center",
    justifyContent: "center",
    minHeight: 48,
  },
  lobbyButton: {
    backgroundColor: "#570405",
  },
  tryAgainButton: {
    backgroundColor: "#2D4869",
  },
  cancelButton: {
    backgroundColor: "#757575",
  },
  buttonText: {
    color: "#ffffff",
    fontSize: 16,
    fontWeight: "600",
  },
});

export default ErrorFindTableModal;